import { getReq } from "./instance";

export const getMoA = async (moAId: string, params = {}) => {
  return getReq(`/MoA/${moAId}`, params);
};
